module.exports = __webpack_public_path__ + "media/images/logo-38d44ab45132c95a890f8d45b5f32d4c.svg";